export default __webpack_public_path__ + "static/media/icon_indicator_green.a1f264ed.png";